 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"8":"8","Case":"Case","Case1":"Case1","Case2":"Case2","Healthcare":"Healthcare","Mote50~gricdMote":"Mote50~gricdMote","Mote50":"Mote50","gricdMote":"gricdMote","OurStory":"OurStory","Privacy":"Privacy","agriculture":"agriculture","blog":"blog","blog1":"blog1","blog10":"blog10","blog11":"blog11","blog12":"blog12","blog13":"blog13","blog14":"blog14","blog15":"blog15","blog16":"blog16","blog17":"blog17","blog18":"blog18","blog19":"blog19","blog2":"blog2","blog20":"blog20","blog3":"blog3","blog4":"blog4","blog5":"blog5","blog6":"blog6","blog7":"blog7","blog9":"blog9","contact~demo":"contact~demo","contact":"contact","demo":"demo","cold-chain":"cold-chain","demoSucess":"demoSucess","logistics":"logistics","thecontainerAbuou":"thecontainerAbuou","thecontainerApp":"thecontainerApp","thecontainerContact":"thecontainerContact","thecontainerProduct":"thecontainerProduct","thecontainerblog":"thecontainerblog"}[chunkId]||chunkId) + "." + {"8":"5d64202c","Case":"bd437fbc","Case1":"ec2cc807","Case2":"ba664ddc","Healthcare":"24d4ced4","Mote50~gricdMote":"0645f5f5","Mote50":"0e75de8b","gricdMote":"123ee7a7","OurStory":"acca54dd","Privacy":"f1506df0","agriculture":"4c4c9a80","blog":"c54c1912","blog1":"6dc99045","blog10":"143cfb4a","blog11":"fe33c7fc","blog12":"5d2f59c9","blog13":"106fb459","blog14":"63af8367","blog15":"94e8f7d0","blog16":"59838a01","blog17":"c5952810","blog18":"9bb7e611","blog19":"9193dbfa","blog2":"5042992a","blog20":"7d329b3f","blog3":"c941c8a5","blog4":"9ae4615d","blog5":"2423a740","blog6":"3377b5f7","blog7":"778c1fe4","blog9":"b904d405","chunk-23adc360":"a76639f3","chunk-4c3d987a":"b1d17f5a","contact~demo":"02c35d05","contact":"8fe342ff","demo":"2584c09b","cold-chain":"5ca962e8","demoSucess":"6b6f687c","logistics":"744702fc","thecontainerAbuou":"9a0d5832","thecontainerApp":"6e7d5244","thecontainerContact":"150bcfa0","thecontainerProduct":"b25527b0","thecontainerblog":"912ce023"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"8":1,"Case":1,"Case1":1,"Case2":1,"Healthcare":1,"Mote50~gricdMote":1,"Mote50":1,"gricdMote":1,"OurStory":1,"agriculture":1,"blog":1,"blog1":1,"blog10":1,"blog11":1,"blog12":1,"blog13":1,"blog14":1,"blog15":1,"blog16":1,"blog17":1,"blog18":1,"blog19":1,"blog2":1,"blog20":1,"blog3":1,"blog4":1,"blog5":1,"blog6":1,"blog7":1,"blog9":1,"chunk-23adc360":1,"chunk-4c3d987a":1,"contact~demo":1,"contact":1,"demo":1,"cold-chain":1,"demoSucess":1,"logistics":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"8":"8","Case":"Case","Case1":"Case1","Case2":"Case2","Healthcare":"Healthcare","Mote50~gricdMote":"Mote50~gricdMote","Mote50":"Mote50","gricdMote":"gricdMote","OurStory":"OurStory","Privacy":"Privacy","agriculture":"agriculture","blog":"blog","blog1":"blog1","blog10":"blog10","blog11":"blog11","blog12":"blog12","blog13":"blog13","blog14":"blog14","blog15":"blog15","blog16":"blog16","blog17":"blog17","blog18":"blog18","blog19":"blog19","blog2":"blog2","blog20":"blog20","blog3":"blog3","blog4":"blog4","blog5":"blog5","blog6":"blog6","blog7":"blog7","blog9":"blog9","contact~demo":"contact~demo","contact":"contact","demo":"demo","cold-chain":"cold-chain","demoSucess":"demoSucess","logistics":"logistics","thecontainerAbuou":"thecontainerAbuou","thecontainerApp":"thecontainerApp","thecontainerContact":"thecontainerContact","thecontainerProduct":"thecontainerProduct","thecontainerblog":"thecontainerblog"}[chunkId]||chunkId) + "." + {"8":"d34b04a3","Case":"8795be97","Case1":"729d9503","Case2":"f5f78be3","Healthcare":"a70c1af6","Mote50~gricdMote":"2cedad0e","Mote50":"b8e2cbae","gricdMote":"fb679095","OurStory":"b1af07f7","Privacy":"31d6cfe0","agriculture":"cee84d4c","blog":"d794d46c","blog1":"6fe4996f","blog10":"7613a62e","blog11":"3851b8e4","blog12":"b67c4839","blog13":"2808df51","blog14":"2d54746f","blog15":"9d99bedb","blog16":"c7f70f35","blog17":"e67dd9a9","blog18":"d83b47ba","blog19":"ae7f3e0a","blog2":"bdc98732","blog20":"f0ec526c","blog3":"6db1d107","blog4":"80aeaff0","blog5":"3e72d211","blog6":"51160a2a","blog7":"9f9e04b7","blog9":"f017362b","chunk-23adc360":"27cccd73","chunk-4c3d987a":"66082e99","contact~demo":"0100f95f","contact":"26d356ee","demo":"fe14d9ea","cold-chain":"494fc564","demoSucess":"d678ba01","logistics":"a1c0e4e8","thecontainerAbuou":"31d6cfe0","thecontainerApp":"31d6cfe0","thecontainerContact":"31d6cfe0","thecontainerProduct":"31d6cfe0","thecontainerblog":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
